import React from "react";
import { Navigation } from "../components/Navigation";
import { Footer } from "../components/Footer";
import { BeamsBackground } from "../components/BeamsBackground";
import { motion } from "framer-motion";
export function ContactPage() {
  return <BeamsBackground intensity="strong" data-id="element-132">
      <Navigation data-id="element-133" />
      <main className="min-h-screen pt-24 pb-16 flex items-center bg-neutral-950" data-id="element-134">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full" data-id="element-135">
          <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-136">
            <div className="text-left" data-id="element-137">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8
            }} data-id="element-138">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-139">
                  Contact Me
                </h1>
                <div className="space-y-6" data-id="element-140">
                  <p className="text-lg md:text-xl text-white/80" data-id="element-141">
                    For more information or anyway I can add value please send
                    me an email at{" "}
                    <a href="mailto:admin@ejminspire.com" className="text-white hover:text-white/90 underline decoration-white/30 hover:decoration-white/60 transition-colors" data-id="element-142">
                      admin@ejminspire.com
                    </a>
                  </p>
                  <p className="text-lg md:text-xl text-white/80" data-id="element-143">
                    Thank you and I look forward to meeting you.
                  </p>
                  <p className="text-lg md:text-xl text-white italic" data-id="element-144">
                    - Elliot Martinez
                  </p>
                </div>
              </motion.div>
            </div>
            <motion.div className="relative flex justify-center items-center" initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-145">
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/422c65e1-da42-44ab-8112-d42089c41cc8/SHOT_1-70.jpg" alt="Elliot Martinez" className="w-full max-w-[500px] h-auto rounded-xl" style={{
              filter: "drop-shadow(0 25px 25px rgb(0 0 0 / 0.4))"
            }} data-id="element-146" />
            </motion.div>
          </div>
        </div>
      </main>
      <Footer data-id="element-147" />
    </BeamsBackground>;
}